import React, { useState } from "react";
import "./style.css";
import Typed from "react-typed";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fab } from "@fortawesome/free-brands-svg-icons";
import { far } from "@fortawesome/free-regular-svg-icons";
import { fas } from "@fortawesome/free-solid-svg-icons";
import { faCirclePlay } from "@fortawesome/free-solid-svg-icons";
import { Modal } from "react-bootstrap";

library.add(fab, far, fas);

const RetroBackground = () => {
  const [isShutdown, setIsShutdown] = useState(false);

  const handleSunClick = () => {
    setIsShutdown(!isShutdown);
  };
  const typedStrings = [
    " Software Engineer",
    " Tutor",
    " Freelancer",
    " Photographer",
    " Footballer",
    " Gamer",
  ];

  const [showModal, setShowModal] = useState(false);

  const handleIconClick = () => {
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };
  const [isMobileNavActive, setIsMobileNavActive] = useState(false);

  return (
    <div
      id="retrobg"
      className={isShutdown ? "retrobg-shutdown" : ""}
      style={{ minHeight: "100vh" }}
      onClick={handleSunClick}
    >
      <div id="retrobg-sky">
        <div className="retrobg-stars">
          <div
            className="retrobg-star"
            style={{ left: "5%", top: "55%", transform: "scale(2)" }}
          ></div>
          <div
            className="retrobg-star"
            style={{ left: "7%", top: "5%", transform: "scale(2)" }}
          ></div>
          <div
            className="retrobg-star"
            style={{ left: "10%", top: "45%", transform: "scale(1)" }}
          ></div>
          <div
            className="retrobg-star"
            style={{ left: "12%", top: "35%", transform: "scale(1)" }}
          ></div>
          <div
            className="retrobg-star"
            style={{ left: "15%", top: "39%", transform: "scale(1)" }}
          ></div>
          <div
            className="retrobg-star"
            style={{ left: "20%", top: "10%", transform: "scale(1)" }}
          ></div>
          <div
            className="retrobg-star"
            style={{ left: "35%", top: "50%", transform: "scale(2)" }}
          ></div>
          <div
            className="retrobg-star"
            style={{ left: "40%", top: "16%", transform: "scale(2)" }}
          ></div>
          <div
            className="retrobg-star"
            style={{ left: "43%", top: "28%", transform: "scale(1)" }}
          ></div>
          <div
            className="retrobg-star"
            style={{ left: "45%", top: "30%", transform: "scale(3)" }}
          ></div>
          <div
            className="retrobg-star"
            style={{ left: "55%", top: "18%", transform: "scale(1)" }}
          ></div>
          <div
            className="retrobg-star"
            style={{ left: "60%", top: "23%", transform: "scale(1)" }}
          ></div>
          <div
            className="retrobg-star"
            style={{ left: "62%", top: "44%", transform: "scale(2)" }}
          ></div>
          <div
            className="retrobg-star"
            style={{ left: "67%", top: "27%", transform: "scale(1)" }}
          ></div>
          <div
            className="retrobg-star"
            style={{ left: "75%", top: "10%", transform: "scale(2)" }}
          ></div>
          <div
            className="retrobg-star"
            style={{ left: "80%", top: "25%", transform: "scale(1)" }}
          ></div>
          <div
            className="retrobg-star"
            style={{ left: "83%", top: "57%", transform: "scale(1)" }}
          ></div>
          <div
            className="retrobg-star"
            style={{ left: "90%", top: "29%", transform: "scale(2)" }}
          ></div>
          <div
            className="retrobg-star"
            style={{ left: "95%", top: "5%", transform: "scale(1)" }}
          ></div>
          <div
            className="retrobg-star"
            style={{ left: "96%", top: "72%", transform: "scale(1)" }}
          ></div>
          <div
            className="retrobg-star"
            style={{ left: "98%", top: "70%", transform: "scale(3)" }}
          ></div>
        </div>

        <div id="retrobg-sunWrap" onClick={handleSunClick}>
          <div
            className="text-center "
            style={{
              color: "#fff",

              // width: "100vw",
              paddingTop: "5rem",
              marginTop: "50vh",
            }}
            onClick={handleSunClick}
          >
            <div
              style={{
                fontWeight: "bold",
                fontSize: "40px",
                paddingTop: "5rem",
              }}
            >
              Isaiah
            </div>
            <p>
              <Typed
                strings={typedStrings}
                typeSpeed={40}
                backSpeed={50}
                loop
              />
            </p>
          </div>
          <div onClick={handleSunClick} id="retrobg-sun"></div>
        </div>
        <div id="retrobg-mountains">
          <div id="retrobg-mountains-left" className="retrobg-mountain"></div>
          <div id="retrobg-mountains-right" className="retrobg-mountain"></div>
        </div>
        <div id="retrobg-cityWrap" onClick={handleSunClick}>
          <div id="retrobg-city">
            <div
              style={{ left: "4.0%", height: "20%", width: "3.0%" }}
              className="retrobg-building"
            ></div>
            <div
              style={{ left: "6.0%", height: "50%", width: "1.5%" }}
              className="retrobg-building"
            ></div>
            <div
              style={{ left: "8.0%", height: "25%", width: "4.0%" }}
              className="retrobg-building"
            ></div>
            <div
              style={{ left: "12.0%", height: "30%", width: "3.0%" }}
              className="retrobg-building"
            ></div>
            <div
              style={{ left: "13.0%", height: "55%", width: "3.0%" }}
              className="retrobg-building retrobg-antenna"
            ></div>
            <div
              style={{ left: "17.0%", height: "20%", width: "4.0%" }}
              className="retrobg-building"
            ></div>
            <div
              style={{ left: "18.5%", height: "70%", width: "1.5%" }}
              className="retrobg-building"
            ></div>
            <div
              style={{ left: "20.0%", height: "30%", width: "4.0%" }}
              className="retrobg-building"
            ></div>
            <div
              style={{ left: "21.5%", height: "80%", width: "2.0%" }}
              className="retrobg-building retrobg-antenna"
            ></div>
            <div
              style={{ left: "25.0%", height: "60%", width: "4.0%" }}
              className="retrobg-building"
            ></div>
            <div
              style={{ left: "28.0%", height: "40%", width: "4.0%" }}
              className="retrobg-building"
            ></div>
            <div
              style={{ left: "30.0%", height: "70%", width: "4.0%" }}
              className="retrobg-building"
            ></div>
            <div
              style={{ left: "35.0%", height: "65%", width: "4.0%" }}
              className="retrobg-building retrobg-antenna"
            ></div>
            <div
              style={{ left: "38.0%", height: "40%", width: "3.0%" }}
              className="retrobg-building"
            ></div>
            <div
              style={{ left: "42.0%", height: "60%", width: "2.0%" }}
              className="retrobg-building"
            ></div>
            <div
              style={{ left: "43.0%", height: "85%", width: "4.0%" }}
              className="retrobg-building retrobg-antenna"
            ></div>
            <div
              style={{ left: "45.0%", height: "40%", width: "3.0%" }}
              className="retrobg-building"
            ></div>
            <div
              style={{ left: "48.0%", height: "25%", width: "3.0%" }}
              className="retrobg-building"
            ></div>
            <div
              style={{ left: "50.0%", height: "80%", width: "4.0%" }}
              className="retrobg-building"
            ></div>
            <div
              style={{ left: "52.0%", height: "32%", width: "5.0%" }}
              className="retrobg-building"
            ></div>
            <div
              style={{ left: "55.0%", height: "55%", width: "3.0%" }}
              className="retrobg-building retrobg-antenna"
            ></div>
            <div
              style={{ left: "58.0%", height: "45%", width: "4.0%" }}
              className="retrobg-building"
            ></div>
            <div
              style={{ left: "61.0%", height: "90%", width: "4.0%" }}
              className="retrobg-building"
            ></div>
            <div
              style={{ left: "66.0%", height: "99%", width: "4.0%" }}
              className="retrobg-building retrobg-antenna"
            ></div>
            <div
              style={{ left: "69.0%", height: "30%", width: "4.0%" }}
              className="retrobg-building"
            ></div>
            <div
              style={{ left: "73.5%", height: "90%", width: "2.0%" }}
              className="retrobg-building"
            ></div>
            <div
              style={{ left: "72.0%", height: "70%", width: "4.0%" }}
              className="retrobg-building"
            ></div>
            <div
              style={{ left: "75.0%", height: "60%", width: "4.0%" }}
              className="retrobg-building"
            ></div>
            <div
              style={{ left: "80.0%", height: "40%", width: "4.0%" }}
              className="retrobg-building"
            ></div>
            <div
              style={{ left: "83.0%", height: "70%", width: "4.0%" }}
              className="retrobg-building retrobg-antenna"
            ></div>
            <div
              style={{ left: "87.0%", height: "60%", width: "3.0%" }}
              className="retrobg-building retrobg-antenna"
            ></div>
            <div
              style={{ left: "93.0%", height: "50%", width: "3.0%" }}
              className="retrobg-building"
            ></div>
            <div
              style={{ left: "91.0%", height: "30%", width: "4.0%" }}
              className="retrobg-building"
            ></div>
            <div
              style={{ left: "94.0%", height: "20%", width: "3.0%" }}
              className="retrobg-building"
            ></div>
            <div
              style={{ left: "98.0%", height: "35%", width: "2.0%" }}
              className="retrobg-building"
            ></div>
          </div>
        </div>
      </div>

      <div id="retrobg-ground">
        <div id="retrobg-linesWrap">
          <div id="retrobg-lines">
            <div id="retrobg-vlines">
              <div className="retrobg-vline"> </div>
              <div className="retrobg-vline"></div>
              <div className="retrobg-vline"></div>
              <div className="retrobg-vline"></div>
              <div className="retrobg-vline"></div>
              <div className="retrobg-vline"></div>
              <div className="retrobg-vline"></div>
              <div className="retrobg-vline"></div>
              <div className="retrobg-vline"></div>
              <div className="retrobg-vline"></div>
              <div className="retrobg-vline"></div>
              <div className="retrobg-vline"></div>
              <div className="retrobg-vline"></div>
              <div className="retrobg-vline"></div>
              <div className="retrobg-vline"></div>
              <div className="retrobg-vline"></div>
              <div className="retrobg-vline"></div>
              <div className="retrobg-vline"></div>
              <div className="retrobg-vline"></div>
              <div className="retrobg-vline"></div>
              <div className="retrobg-vline"></div>
              <div className="retrobg-vline"></div>
              <div className="retrobg-vline"></div>
              <div className="retrobg-vline"></div>
              <div className="retrobg-vline"></div>
              <div className="retrobg-vline"></div>
              <div className="retrobg-vline"></div>
              <div className="retrobg-vline"></div>
              <div className="retrobg-vline"></div>
              <div className="retrobg-vline"></div>
              <div className="retrobg-vline"></div>
              <div className="retrobg-vline"></div>
              <div className="retrobg-vline"></div>
              <div className="retrobg-vline"></div>
              <div className="retrobg-vline"></div>
              <div className="retrobg-vline"></div>
              <div className="retrobg-vline"></div>
              <div className="retrobg-vline"></div>
              <div className="retrobg-vline"></div>
              <div className="retrobg-vline"></div>
              <div className="retrobg-vline"></div>
              <div className="retrobg-vline"></div>
              <div className="retrobg-vline"></div>
              <div className="retrobg-vline"></div>
              <div className="retrobg-vline"></div>
              <div className="retrobg-vline"></div>
              <div className="retrobg-vline"></div>
              <div className="retrobg-vline"></div>
              <div className="retrobg-vline"></div>
              <div className="retrobg-vline"></div>
              <div className="retrobg-vline"></div>
              <div className="retrobg-vline"></div>
              <div className="retrobg-vline"></div>
            </div>

            <div id="retrobg-hlines">
              <div className="retrobg-hline"></div>
              <div className="retrobg-hline"></div>
              <div className="retrobg-hline"></div>
              <div className="retrobg-hline"></div>
              <div className="retrobg-hline"></div>
              <div className="retrobg-hline"></div>
              <div className="retrobg-hline"></div>
              <div className="retrobg-hline"></div>
            </div>
          </div>
        </div>
        <div id="retrobg-groundShadow"></div>
      </div>
      <div
        style={{ fontSize: "4rem", marginTop: "50vh", color: "#fff" }}
        className="gradient-text d-flex justify-content-center"
      >
        <FontAwesomeIcon
          icon={faCirclePlay}
          className="fa-beat"
          onClick={handleIconClick}
        />
      </div>

      <Modal show={showModal} onHide={handleCloseModal}>
        <Modal.Body className="d-flex justify-content-center flex-column">
          <p className="text-center"> Take a look at what I build for fun</p>
          <iframe
            src="https://player.cloudinary.com/embed/?public_id=fun_d23vlh&cloud_name=duma2aru7&player[skin]=light"
            allow="autoplay; fullscreen; encrypted-media; picture-in-picture"
            allowFullScreen
            height="450"
            width="auto"
            frameBorder="0"
            controls={false}
          ></iframe>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default RetroBackground;
